<ion-header>
    <app-page-header
                     [hideBorder]="true"
                     pageTitle="Correctional Facility"></app-page-header>
</ion-header>
<ion-content>
    <app-page-template>
        <section id="page-title">
            <p>Search for your facility or browse by jurisdiction</p>
        </section>
        <section id="page-content">

            <ion-card
                      class="mb-3"
                      [routerLink]="['/contacts/new-contact/facility-search-by-text']">
                <div class="d-flex align-items-center">

                    <div class="p-3">
                        <p class="mb-0">Search by facility name or location</p>
                    </div>
                    <div class="pr-2 ml-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                             stroke-linejoin="round"
                             class="lucide lucide-search absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none">
                            <circle cx="11" cy="11" r="8"></circle>
                            <path d="m21 21-4.3-4.3"></path>
                        </svg>
                    </div>
                </div>
            </ion-card>

            <div class="jurisdiction-header text-center">
                <ion-label color="medium">Or Browse by jurisdiction</ion-label>
            </div>

            <ion-card
                      class="mb-3"
                      (click)="selectJurisdiction(0)">
                <div class="d-flex align-items-center">
                    <div class="pl-2 ml-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                             stroke-linejoin="round" class="lucide lucide-landmark w-6 h-6"
                             style="color: rgb(255, 149, 0);">
                            <line x1="3" x2="21" y1="22" y2="22"></line>
                            <line x1="6" x2="6" y1="18" y2="11"></line>
                            <line x1="10" x2="10" y1="18" y2="11"></line>
                            <line x1="14" x2="14" y1="18" y2="11"></line>
                            <line x1="18" x2="18" y1="18" y2="11"></line>
                            <polygon points="12 2 20 7 4 7"></polygon>
                        </svg>
                    </div>
                    <div class="p-3">
                        <h4 class="mt-0">Federal</h4>
                        <p class="mb-0">Federal BOP Bureau of Prisons facilities</p>
                    </div>

                </div>
            </ion-card>

            <ion-card
                      class="mb-3"
                      (click)="selectJurisdiction(1)">
                <div class="d-flex align-items-center">
                    <div class="pl-2 ml-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                             stroke-linejoin="round"
                             class="lucide lucide-building2 lucide-building-2 w-6 h-6"
                             style="color: rgb(255, 149, 0);">
                            <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                            <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                            <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                            <path d="M10 6h4"></path>
                            <path d="M10 10h4"></path>
                            <path d="M10 14h4"></path>
                            <path d="M10 18h4"></path>
                        </svg>
                    </div>
                    <div class="p-3">
                        <h4 class="mt-0">State</h4>
                        <p class="mb-0">State DOC prisons and correctional facilities</p>
                    </div>

                </div>
            </ion-card>

            <ion-card
                      class="mb-3"
                      (click)="selectJurisdiction(2)">
                <div class="d-flex align-items-center">
                    <div class="pl-2 ml-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                             stroke-linejoin="round" class="lucide lucide-map-pin w-6 h-6"
                             style="color: rgb(255, 149, 0);">
                            <path
                                  d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                            </path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                    </div>
                    <div class="p-3">
                        <h4 class="mt-0">Local</h4>
                        <p class="mb-0">County jails, sheriff's, and local detention centers</p>
                    </div>

                </div>
            </ion-card>
        </section>
    </app-page-template>
</ion-content>